import { Task, type TaskList } from '~/data/Asset';
import { InModalMessageProps } from '~/components/views/common/styled/Modal/types';
import { DayName } from './day-names';

export type WeeklyScheduleRecord = Record<
  DayName,
  {
    title: string;
    titleInShort: string;
    taskList?: Task[];
  }
>;

/**
 * Types moved from deprecated TaskSchedulerContext
 */
export type HoverState = {
  hour: number;
  x: number;
  y: number;
  day: number;
};

export type PopoverState = {
  x: number; // clientX
  y: number; // clientY
  missionId: number;
  taskId?: string;
  startTime?: number;
  endTime?: number;
};

export type AreaDetailsInShort = {
  name: string;
  missionId: number;
  enabled?: boolean | null;
};

export type ScheduleUICordConfig = {
  yMapWithMinute: Map<number, number>;
  xMapWitDays: Map<DayName, number>;
  hourBlockHeight: number;
  hourBlockWidth: number;
};

export interface BatchModeConfig {
  assetIds: AssetId[];
  isActive: boolean;
  mowerCount: number;
}

export interface EditModeSchedule {
  startTime: number;
  endTime: number;
  id: string;
  days: DayName[];
  position?: number; // position for deterministic ordering in the editor (0 = top)
}

/** Record that holds tasks as per the time slot */
export type TimeWiseTaskRecord = Record<string, EditModeSchedule>;

export interface SchedulesV2State {
  isOpen: boolean;
  editMode: boolean;
  batchMode: BatchModeConfig;
  isSaveEnabled: boolean;
  assetId: AssetId;
  tasklist?: TaskList;
  selectedMissionId: number | null;
  weeklyScheduleToDisplay: WeeklyScheduleRecord;
  editModeSnapshot: WeeklyScheduleRecord | null; // Snapshot taken when entering edit mode
  isBatchModeInfoVisible: boolean;
  message?: InModalMessageProps;
  supportsMultipleAreas: boolean;
  eposMower: boolean;
  assetName: string;
  areas?: AreaDetailsInShort[];
  // UI state moved from context
  hoverState: HoverState | null;
  popoverState?: PopoverState | null;
  timeWiseTaskRecord?: TimeWiseTaskRecord;
}

export const schedulesV2defaultState: Partial<SchedulesV2State> = {
  isOpen: false,
  editMode: false,
  batchMode: {
    assetIds: [],
    isActive: false,
    mowerCount: 0,
  },
  isSaveEnabled: false,
  selectedMissionId: null,
  isBatchModeInfoVisible: true,
  supportsMultipleAreas: false,
  eposMower: false,
  assetName: '',
  areas: [],
  editModeSnapshot: null,
  // UI state defaults
  hoverState: null,
  weeklyScheduleToDisplay: {
    MONDAY: {
      title: 'bff.days.monday',
      titleInShort: 'bff.days.short.monday',
      taskList: [],
    },
    TUESDAY: {
      title: 'bff.days.tuesday',
      titleInShort: 'bff.days.short.tuesday',
      taskList: [],
    },
    WEDNESDAY: {
      title: 'bff.days.wednesday',
      titleInShort: 'bff.days.short.wednesday',
      taskList: [],
    },
    THURSDAY: {
      title: 'bff.days.thursday',
      titleInShort: 'bff.days.short.thursday',
      taskList: [],
    },
    FRIDAY: {
      title: 'bff.days.friday',
      titleInShort: 'bff.days.short.friday',
      taskList: [],
    },
    SATURDAY: {
      title: 'bff.days.saturday',
      titleInShort: 'bff.days.short.saturday',
      taskList: [],
    },
    SUNDAY: {
      title: 'bff.days.sunday',
      titleInShort: 'bff.days.short.sunday',
      taskList: [],
    },
  },
  timeWiseTaskRecord: {},
};
